function CheckMailersIcon() {
    return (
        <svg
            id="Layer_2"
            data-name="Layer 2"
            fill="#ffffff"
            width="35"
            height="35"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 45.8 45.8">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="m39.21,41.94l-28.97-.11-4.39-8.68,29.3.11,4.06,8.68h0Zm-28.6-.63l27.7.1-3.53-7.62-28.02-.1,3.86,7.62Z" />
                <path d="m14.84,36.83l-5.25-.06-.93-1.84,5.25.06.93,1.84Zm-4.87-.58l3.97.05-.4-.79-3.97-.05.4.79Z" />
                <path d="m10.15,37.87l17.13.06.27.53-17.13-.06-.27-.53Z" />
                <path d="m11,39.56l12.93.04.27.53-12.93-.04-.27-.53Z" />
                <g>
                    <path d="m32.7,39.44h.64s.39.78.39.78h-.64s-.39-.78-.39-.78Z" />
                    <path d="m30.49,35.09h.64s.38.76.38.76h-.64s-.38-.76-.38-.76Z" />
                    <path d="m33.54,39.72h-.79c-.75-.02-1.61-.52-1.92-1.12h.64c.16.32.61.58,1.01.58h.79c.45.01.67-.27.49-.62-.09-.17-.25-.33-.46-.45-.22-.12-.46-.19-.67-.2h-.79c-.8-.02-1.72-.55-2.04-1.19-.16-.31-.15-.6.01-.82.16-.21.47-.33.85-.33h.79c.75.02,1.61.52,1.92,1.12h-.64c-.16-.32-.61-.58-1.01-.58h-.79c-.22-.01-.39.05-.48.17-.09.12-.09.28,0,.44.18.35.69.64,1.13.65h.79c.39.01.81.14,1.19.36.39.22.69.52.85.83.32.64-.06,1.16-.86,1.15h0Z" />
                </g>
                <path d="m7.14,45.34c.12.3.4.46.76.46h37c.27,0,.58-.17.79-.42.06-.13.11-.31.11-.48s0-.26-.04-.33l-6.83-14.47,6.37-13.6.12-.09c.24-.18.38-.45.38-.71,0-.08-.01-.15-.04-.25l-.02-.13c0-.13-.03-.25-.08-.35L38.66.46c-.12-.3-.4-.46-.76-.46H.9C.62,0,.36.17.26.42l-.08.14c-.15.2-.16.48-.02.82l6.81,14.32L.22,29.84c-.14.17-.22.37-.22.56s.08.36.15.46l6.99,14.48Zm36.4-1.34H8.52l-6.15-12.7h35.23l5.95,12.7ZM2.35,1.8h34.93l6.3,13H8.54L2.35,1.8Zm6.14,14.8h34.81l-6.04,12.9H2.36l6.13-12.9Z" />
            </g>
        </svg>
    )
}

export default CheckMailersIcon
